var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#link_svg__a)",
  fill: "#544F5A"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.148 7.721-1.449 1.46a2.224 2.224 0 0 1-3.135-.022A2.256 2.256 0 0 1 1.542 6l1.448-1.46a.449.449 0 0 0-.314-.763.443.443 0 0 0-.314.13L.914 5.369A3.154 3.154 0 0 0 0 7.592c0 .834.33 1.633.915 2.223.585.589 1.38.92 2.207.92a3.11 3.11 0 0 0 2.206-.922l1.449-1.458a.449.449 0 0 0-.316-.758.442.442 0 0 0-.312.125h-.001ZM9.744.922A3.098 3.098 0 0 0 5.332.92L3.88 2.38a.449.449 0 0 0 .314.763c.118 0 .23-.047.314-.131l1.45-1.459a2.216 2.216 0 0 1 2.818-.28 2.263 2.263 0 0 1 .338 3.459l-1.449 1.46a.45.45 0 0 0 .315.763c.117 0 .23-.047.314-.13l1.448-1.459A3.158 3.158 0 0 0 9.744.922Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.347 3.709 3.682 6.392a.447.447 0 0 0 .484.732.444.444 0 0 0 .144-.1L6.975 4.34a.449.449 0 0 0-.316-.758.442.442 0 0 0-.312.126Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "link_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10.657v10.732H0z"
})))));
export default SvgLink;